'use strict';

module.exports = function (marty, React) {
  marty.createStateMixin = require('./createStateMixin')(React);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/state-mixin/index.js
 ** module id = 582
 ** module chunks = 0
 **/